import { ODataHeader, ODataString, ODataDecimal } from "pbas-vue-components";

import { translate2 } from "../trans2";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const headers = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Name"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.term",
    type: new ODataString("Term/Translations[]/Name", {
      getString: (item) => translate2(item.Term, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/StartDate",
  }),
  new ODataHeader({
    type: new ODataString("Term/Year"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.plancreationwizard.membereligibility.period",
    type: new ODataString("Term/Translations[]/Year"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.hourshistory.hours",
    type: new ODataDecimal("Amount"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.employer_contributions.dues",
    type: new ODataDecimal("Dues", {
      getString: (item) => {
        const value = item.Dues;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.payments",
    type: new ODataDecimal("Payments", {
      getString: (item) => {
        const value = item.Payments;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "views.balancepayments.balance",
    type: new ODataDecimal("Balance", {
      getString: (item) => {
        let value = item.Balance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        let formatted = formatter.format(value);
        if (formatted === '-$0.00') {
          formatted = '$0.00'
        }
        return formatted;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
function getHeaders(trackHours) {
  if (trackHours) {
    return headers;
  }
  return headers.filter((o) => o.title !== "headers.hourshistory.hours");
}
export default getHeaders;
